import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { AcceptanceTermsFilterRequest } from '@/main/models/request';

export abstract class IAcceptanceTermsApi {
  abstract save(
    request: AcceptanceTermsFilterRequest
  ): Promise<AxiosResponse<Result<void>>>;
}

